import { render } from "./center.vue?vue&type=template&id=044022bc&scoped=true"
import script from "./center.vue?vue&type=script&lang=js"
export * from "./center.vue?vue&type=script&lang=js"

import "./center.vue?vue&type=style&index=0&id=044022bc&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044022bc"]])

export default __exports__